'use client';
import {useState, useEffect, memo} from 'react';
import {useLazyImageObserver} from '@/components/ui/hooks/useLazyImageObserver';
import {isEmpty} from '@/utils';

/**
 * SoopUiImg 컴포넌트
 * @desc 이미지를 렌더링하고, 이미지 로딩 실패 시 대체 이미지를 보여줌
 * @param {Object} props - 컴포넌트의 props
 * @param {string} props.src - 렌더링할 이미지의 URL
 * @param {string} [props.className] - 이미지의 클래스명
 * @param {string} [props.alt='image'] - 이미지의 alt 값
 * @param {boolean} [props.isPrivate] - 비밀방송 여부
 * @param {'profile' | 'thumbnail' | string} [props.type] - 이미지 타입
 * @returns {JSX.Element} 이미지를 렌더링하는 JSX 요소
 * @returns {Function} current.setSource - 내부 img 태그src 직접 제어
 */

const SoopUiImg = ({
  src,
  className,
  alt = 'image',
  isPrivate = false,
  onError,
  type = '',
  disableLazy = false,
}) => {
  const [isError, setIsError] = useState(false);
  const {imageSrc, imageRef} = useLazyImageObserver({src, type, disableLazy});

  useEffect(() => {
    if (isEmpty(src)) {
      setIsError(true);
    } else {
      setIsError(false);
    }
  }, [src]);

  const handleOnError = () => {
    if (onError) {
      onError();
    }
    setIsError(true);
  };

  if (isEmpty(src) || isEmpty(imageSrc)) return null;
  if (isPrivate || isError) return null;

  //TODO: 추후 Next Image로 변경 필요
  return (
    <img
      ref={imageRef}
      src={imageSrc}
      className={className}
      onError={handleOnError}
      alt={alt}
      loading='lazy'
    />
  );
};

export default memo(SoopUiImg);
